export default __webpack_public_path__ + "static/media/dashboard-illus-1.d075f901.svg";